import { getRevenuesCommunication } from 'api/v2/revenues';
import {
  GeneratedInvoiceFormValues,
  GeneratedInvoiceSubmitValues,
} from 'types/invoice.types';
import { divideBy1000, round } from 'utils/math';
import { getInvoiceItemsTotalInclVAT } from '../../OtherRevenueForm/utils';
import '../styles.scss';

export const getCommunicationDependencies = (
  values: GeneratedInvoiceFormValues,
) => {
  return {
    clientId: values.clientId,
    docNumber: values.revenueNumber,
    useCommunication: !!values.settings.useCommunication,
  };
};

export const getQRCodeDependencies = (values: GeneratedInvoiceFormValues) => {
  const copyrightCalcs = values.itemsCalculations?.copyRight;
  const copyrightFees = copyrightCalcs?.copyrightRevenueTaxAmount || 0;
  return {
    IBAN: values.user.IBAN,
    currency: values.currency!,
    amount: round(
      Math.max(
        getInvoiceItemsTotalInclVAT(values.items || []) -
          divideBy1000(values.downPayment || 0) -
          (values.settings.includeCopyrightReminder ? copyrightFees : 0),
        0,
      ),
    ),
    name:
      values.user.accountHolderName ||
      values.user.companyName ||
      `${values.user.firstName} ${values.user.lastName}`,
    communication: values.settings.useCommunication
      ? values.communication
      : values.revenueNumber,
    usePaymentQrCode: !!values.settings.usePaymentQrCode,
  };
};

export const communicationGuard = async (
  values: GeneratedInvoiceSubmitValues,
) => {
  let communication = values.communication || undefined;

  if (
    values.settings.useCommunication &&
    values.clientId &&
    values.revenueNumber &&
    !communication
  ) {
    communication = await getRevenuesCommunication(
      values.clientId,
      values.revenueNumber,
    );
  }

  return communication;
};
